import { Component, OnInit, OnDestroy } from '@angular/core';
import { firstValueFrom, Subscription } from 'rxjs';
import { Product, ProductCreatePayload, ProductUpdatePayload } from '@mira-avant/mtlibs';
import { ProductService } from '../../../../services/product.service';
import { AngularModule } from '../../../../modules/angular.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { BreadcrumbsComponent } from '../../../ui/admin/breadcrumbs/breadcrumbs.component';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { EngineService } from '../../../../services/engine.service';
import { ProductForm } from '../../../forms/standard/product-form/product-form';
import { ProductsTable } from '../../../ui/admin/products-table/products-table';

@Component({
	selector: 'app-products',
	standalone: true,
	imports: [
		AngularModule,
		ZorroModule,
		NzCardModule,
		NzDividerModule,
		BreadcrumbsComponent,
		ProductForm,
		ProductsTable,
	],
	templateUrl: './products.html',
	styleUrl: './products.scss',
})
export class Products implements OnInit, OnDestroy {
	private subscriptions: Subscription = new Subscription();
	public showProductForm: boolean = false;

	constructor(
		public productService: ProductService,
		public engineService: EngineService
	) {}

	ngOnInit(): void {
		this.subscriptions.add(
			this.productService.selectedProduct$.subscribe(product => {
				if (product) {
					this.showProductForm = true;
				} else {
					this.showProductForm = false;
				}
			})
		);
	}

	public toggleProductForm(): void {
		this.showProductForm = !this.showProductForm;
	}

	public async onProductSubmit(payload: ProductCreatePayload | ProductUpdatePayload): Promise<void> {
		const selectedProduct: Product | undefined = await firstValueFrom(this.productService.selectedProductBs$);
		if (selectedProduct && selectedProduct.name) {
			// Update existing product
			const updatePayload: ProductUpdatePayload = {
				name: payload.name || selectedProduct.name,
				engine_name: payload.engine_name || selectedProduct.engine_name,
			};
			await this.productService.updateProduct$(selectedProduct.name, updatePayload);
		} else {
			if (!payload.name || !payload.engine_name) {
				throw new Error('Missing required fields for product creation');
			}
			const createPayload: ProductCreatePayload = {
				name: payload.name,
				engine_name: payload.engine_name,
			};
			// Create new product
			await this.productService.createProduct$(createPayload);
		}
		this.showProductForm = false;
		this.productService.selectProduct(undefined);
	}

	ngOnDestroy(): void {
		this.subscriptions.unsubscribe();
	}
}
